export const ATTRIBUTE_SOURCE_CONNECTION_DATA = {
  name: "Attribute Source Connection",
  id: "ATTRIBUTE_SOURCE_CONNECTION",
};
